import { configureStore } from '@reduxjs/toolkit';

import { config } from '_config';

import billingSlice from './billing/slice';
import credentialsSlice from './credentials/slice';
import { authorizationCheckMiddleware, notificationSystemMiddleware } from './middlewares';
import modalsSlice from './modals/slice';
import orderSlice from './order/slice';
import ordersSlice from './orders/slice';
import userSlice from './user/slice';

export default configureStore({
  reducer: {
    user: userSlice,
    credentials: credentialsSlice,
    order: orderSlice,
    orders: ordersSlice,
    billing: billingSlice,
    modals: modalsSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat([
      authorizationCheckMiddleware,
      notificationSystemMiddleware,
    ]),
  devTools: config.devtools === 'true',
});
